module.exports = __webpack_public_path__ + "static/media/laptop_phone_reporting.62584279.png";